// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import type { IssueTypeWithPinnedFields, State } from './IssueType.types.tsx';

type IssueTypeId = string;
type ProjectId = string;

type IssueTypeWithProjectId = IssueTypeWithPinnedFields & {
	projectId: ProjectId;
};

export const populateIssueTypes =
	({ issueTypes }: { issueTypes: IssueTypeWithProjectId[] }) =>
	async ({ setState, getState }: StoreActionApi<State>): Promise<void> => {
		const issueTypesById: Record<IssueTypeId, IssueTypeWithProjectId> = {};
		const issueTypesByProjectId: Record<ProjectId, IssueTypeId[]> = {};

		issueTypes.forEach((issueType) => {
			const existingIssueType = getState().issueTypesById[issueType.id];

			issueTypesById[issueType.id] = {
				...existingIssueType,
				...issueType,
				operation: existingIssueType?.operation ?? issueType.operation,
			};

			if (!issueTypesByProjectId[issueType.projectId]) {
				if (fg('jpd_fix_roadmap_view_loading')) {
					issueTypesByProjectId[issueType.projectId] = [
						...(getState().issueTypesByProjectId[issueType.projectId] ?? []),
					];
				} else {
					issueTypesByProjectId[issueType.projectId] =
						getState().issueTypesByProjectId[issueType.projectId] ?? [];
				}
			}

			if (!issueTypesByProjectId[issueType.projectId].includes(issueType.id)) {
				issueTypesByProjectId[issueType.projectId].push(issueType.id);
			}
		});

		setState({
			issueTypesById: {
				...getState().issueTypesById,
				...issueTypesById,
			},
			issueTypesByProjectId: {
				...getState().issueTypesByProjectId,
				...issueTypesByProjectId,
			},
		});
	};
